export default "dist/images/block-blog-posts-basic.e662046.png";